import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import type { EmptyObject } from 'type-fest'
import { getAboutUsPageData } from '@components/AboutUsPage/AboutUsPage.utils'
import type { HeroProps } from '@components/Hero/Hero.types'
import { lazyImport } from '@helpers'
import { withErrorBoundary, withI18next, withSuspense, withTheme } from '@hocs'

const { AboutUsPage } = lazyImport(
  () => import('@components/AboutUsPage/AboutUsPage'),
  'AboutUsPage',
)

const aboutUsPageEl = document.getElementById('about-us-page')
const aboutUsPageData = aboutUsPageEl ? getAboutUsPageData() : null

interface AboutUsPageAppParams {
  heroData: HeroProps | EmptyObject
}

export const renderAboutUsPageApp = ({ heroData }: AboutUsPageAppParams) => {
  if (aboutUsPageEl && aboutUsPageData) {
    const AboutUsPageAppComponent = () => (
      <AboutUsPage heroProps={heroData} rows={aboutUsPageData.rows} />
    )

    const AboutUsPageAppWrapper = pipe(
      AboutUsPageAppComponent,
      withSuspense,
      withI18next,
      withErrorBoundary,
      withTheme,
    )

    ReactDOM.createRoot(aboutUsPageEl).render(<AboutUsPageAppWrapper />)
  }
}
